import { useContext } from 'react';
import { SetsModeContext } from './index';

export function useSetsMode() {
  const context = useContext(SetsModeContext);
  if (!context) {
    throw new Error('useSetsMode must be used within SetsModeContext');
  }
  return context;
}
